export function openWebinarIndividualVideo(webinarId) {
  const component = document.querySelector(`[data-iframe-id="${webinarId}"]`);

  if (component) {
    component.classList.remove('webinar-individual-frame--hidden');

    component.querySelector('[data-iframe-close]').onclick = () => {
      component.classList.add('webinar-individual-frame--hidden');

      (component.querySelectorAll('iframe') || []).forEach((frame) => {
        frame.setAttribute('src', frame.getAttribute('src'));
      });
    };
  }

  return true;
}
